// AuthLayout
import { React, useState } from 'react';
import DashboardSidebar from './DashboardSidebar';
import DashboardNavbar from './DashboardNavbar';
import PublicNavbar from './Navbar';
import MinimalNavbar from './MinimalNavbar';

const AuthLayout = ({ children }) => {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  return (
    <div className="flex min-h-screen bg-gray-50 font-source-sans-3">
      <DashboardSidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />
      <div className={`flex-1 transition-all duration-300 ${sidebarExpanded ? 'md:ml-60' : 'md:ml-8'}`}>
        <DashboardNavbar sidebarExpanded={sidebarExpanded} />
        <main className="px-6 py-8">
          {children}
        </main>
      </div>
    </div>
  );
};

// PublicLayout
const PublicLayout = ({ children }) => {
  return (
    <>
      <PublicNavbar />
      <main className="min-h-screen">
        {children}
      </main>
    </>
  );
};

// MinimalLayout
const MinimalLayout = ({ children }) => {
  return (
    <>
      <MinimalNavbar />
      <main className="min-h-screen">
        {children}
      </main>
    </>
  );
};

export { AuthLayout, PublicLayout, MinimalLayout };